import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

export async function destroyOrganization(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/destroy`;

  const response = await api.executePutRequest<ObjectResponse<{ id: string; destroyed: boolean }>>(url);

  return response.data;
}
